<div class="container mat-typography" role="alert">
    <div class="content" *ngIf="state$ | async as state">
        <ng-container *ngIf="state.kind === 'on_kraken'">
            <h1>Your organisation is on the new version of Octiga</h1>
            <p class="lead">The classic version of Octiga no longer serves your organisation.</p>

            <div class="actions">
                <button *ngIf="state.krakenUrl" mat-raised-button color="primary" (click)="openKraken(state.krakenUrl)">
                    Open the new version
                </button>

                <ng-container *ngIf="switchBack$ | async as switchBack">
                    <p *ngIf="switchBack.phase === 'sent'" class="notice switch-back-sent">
                        Request sent — we've let our team know that {{ switchBack.mspName }} would like to return to the
                        classic version.<ng-container *ngIf="upn"> We'll be in touch at {{ upn }}.</ng-container>
                    </p>
                    <ng-container *ngIf="switchBack.phase !== 'sent'">
                        <p *ngIf="switchBack.phase === 'error'" class="notice switch-back-error">
                            We couldn't send your request. Try again, or email
                            <a href="mailto:support@octiga.com">support&#64;octiga.com</a>
                        </p>
                        <button mat-stroked-button [disabled]="switchBack.phase === 'working' || !mspId"
                            (click)="requestSwitchBack()">
                            {{ switchBack.phase === 'error' ? 'Try again' : 'Request a switch back to the classic version' }}
                        </button>
                    </ng-container>
                </ng-container>
            </div>

            <div class="meta">
                <p *ngIf="upn" class="signed-in-as">Signed in as <b>{{ upn }}</b></p>
                <p><a href="mailto:support@octiga.com">support&#64;octiga.com</a></p>
            </div>
        </ng-container>

        <ng-container *ngIf="state.kind === 'switching'">
            <mat-spinner class="spinner"></mat-spinner>
            <h1>
                {{ directionText(state) ? 'Your organisation is being switched ' + directionText(state) : "We're checking your organisation's version of Octiga" }}
            </h1>
            <p class="lead">This takes a few minutes. This page will continue automatically.</p>
        </ng-container>
    </div>
</div>
